import React, { createContext, useContext, useState } from 'react'

interface SearchQuery {
  param: string
  value: string
}

interface DataFetchContextType {
  searchQuery: SearchQuery
  setSearchQuery: (query: SearchQuery) => void
  offset: number
  setOffset: (update: number | ((prevOffset: number) => number)) => void
}

interface DataFetchProviderProps {
  children: React.ReactNode
}

const DataFetchContext = createContext<DataFetchContextType | undefined>(undefined)

export const DataFetchProvider: React.FC<DataFetchProviderProps> = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({ param: '', value: '' })
  const [offset, setOffset] = useState<number>(0)

  return (
    <DataFetchContext.Provider value={{ searchQuery, setSearchQuery, offset, setOffset }}>
      {children}
    </DataFetchContext.Provider>
  )
}

export const useDataFetch = (): DataFetchContextType => {
  const context = useContext(DataFetchContext)
  if (!context) {
    throw new Error('useDataFetch must be used within a DataFetchProvider')
  }
  return context
}
